
import { BaseTopMenu } from "./top-menu";
import router from "@/router";

export class DemoTopMenu extends BaseTopMenu {
    async created() {
      this.username = "John Doe";
    }
  
    async logout() {
      router.replace('/');

    }

    async mounted() {
      const site: any = localStorage.getItem("demo_site");
      this.options = JSON.parse(site);
      this.options.name = this.options.text;
    }
}